// extracted by mini-css-extract-plugin
export default {"socialLink":"c-h_gH","socialLink__link":"c-h_gJ","socialLink__icon":"c-h_gK","socialLink_withScaleOnHover":"c-h_gL"};